export const isCartEmptySelector = (state) => {
    return (
        !Object.keys(state.cart.items).length &&
        !state.cart.promocodeProducts.id
    );
};
